module.exports = __webpack_public_path__ + "assets/img/whybuyaudiapproved1.e6fc0c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/whybuyaudiapproved1.jpg
// module id = F/ek
// module chunks = 1